// --- START PATCH: App entry point with providers ---
import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/global.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthProvider.tsx";
import { CartProvider } from "@/features/cart/context/CartProvider";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/config";

// Initialize default language for first-time visitors
// This ensures Portuguese is the default before any rendering happens
try {
  if (!localStorage.getItem('i18nextLng')) {
    localStorage.setItem('i18nextLng', 'pt-PT');
  }
} catch (error) {
  // Silently ignore errors in environments where localStorage is not available
  // (e.g., SSR, private browsing modes, certain mobile browsers)
}

// Fallback component while translations load
function I18nFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<I18nFallback />}>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </Suspense>
    </I18nextProvider>
  </React.StrictMode>
);
// --- END PATCH: App entry point with providers ---
